import qs from "qs";

import type {
  CreateSupplierUsers,
  CreateTicketRequest,
  CreateUpdateAwardRequest,
  CreateUpdateOfferingRequest,
  ISuppliersFilters,
  SupplierQuestionnaireRequest,
  SupplierUserView,
  UpdateSupplierRequest,
} from "~/Core/Models";

import axios from "./config";

const SCHEMA = "/supplier";

export function GetSupplierProfile() {
  return axios.get(`${SCHEMA}/profile`);
}

export function GetSupplierTypes() {
  return axios.get(`${SCHEMA}/types`);
}

export function Overview() {
  return axios.get(`${SCHEMA}/overview`);
}

export function UpdateSupplier(data: UpdateSupplierRequest) {
  return axios.patch(`${SCHEMA}`, data);
}

export function GetCategories(parents?: string[]) {
  return axios.get(`/categories`, {
    params: { parents },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function SearchCategories(query?: string) {
  return axios.get(`/categories/search`, {
    params: { query },
  });
}

// /////////////////      Users          ///////////////
export function CreateUserSupplier(data: CreateSupplierUsers) {
  return axios.post(`${SCHEMA}/user`, data);
}

export function UpdateUserSupplier(data: SupplierUserView) {
  return axios.put(`${SCHEMA}/user/${data.id}`, data);
}

export function DeleteUserSupplier(id: string | number) {
  return axios.delete(`${SCHEMA}/user/${id}`);
}

// /////////////////      Offers          ///////////////
export function GetAllSupplierOffers() {
  return axios.get(`${SCHEMA}/offering/all`);
}

export function AddUpdateSupplierOffer(data: CreateUpdateOfferingRequest) {
  return axios.post(`${SCHEMA}/offering`, data);
}

export function DeleteSupplierOffer(id: string | number) {
  return axios.delete(`${SCHEMA}/offering/${id}`);
}

export function UpdateOffer(data: CreateUpdateOfferingRequest & { id: number | string }) {
  return axios.put(`${SCHEMA}/offering/${data.id}`, data);
}

// /////////////////      Awards          ///////////////

export function UpdateAwards(data: CreateUpdateAwardRequest) {
  return axios.put(`${SCHEMA}/awards`, data);
}

export function DeleteAwards(id: string | number) {
  return axios.delete(`${SCHEMA}/awards/${id}`);
}

export function GetAllTickets(filters: ISuppliersFilters) {
  return axios.get(`${SCHEMA}/tickets`, { params: filters });
}

export function AddTicket(data: CreateTicketRequest) {
  return axios.post(`${SCHEMA}/tickets`, data);
}

// ///////////////////////////////////////// questionnaire /////////
export function UpdateQuestionnaire(data: SupplierQuestionnaireRequest) {
  return axios.put(`${SCHEMA}/questionnaire`, data);
}
export function GetAllQuestions() {
  return axios.get(`${SCHEMA}/questionnaire/questions`);
}

export function SubmitSupplier() {
  return axios.post(`${SCHEMA}/submit`);
}
